import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { SwitchProps } from "./types";

const DynamicDashboardSwitch = dynamic(() => import("./DashboardSwitchSsr").then((mod) => mod.DashboardSwitchSsr), {
  ssr: false,
});

export const DashboardSwitch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => (
  <DynamicDashboardSwitch {...props} forwardedRef={ref} />
));

DashboardSwitch.displayName = "DashboardSwitch";
